import { Theme } from '@mui/material';
import styled from '@emotion/styled';
import { useContext, useEffect, useState } from 'react';

import { DataContext } from 'providers/data';

import ButtonMui from '@mui/material/Button';
import Typography from '@mui/material/Typography';
import AccordionMui from '@mui/material/Accordion';
import AccordionDetailsMui from '@mui/material/AccordionDetails';
import AccordionSummaryMui from '@mui/material/AccordionSummary';

import { ReactComponent as TakeQuestionsIcon } from 'assets/icons/take-questions-icon.svg';
import { ReactComponent as TakeArrowQuestionsIcon } from 'assets/icons/take-arrow-questions-icon.svg';

type Params = {
    icon: any;
    title: string;
    text?: string;
    price: string;
    description: string;
    VL_COMISSAO: number;
    nrTypeProduct: number;
    cdQuotationItem: string;
    codProductSingle: number;
    nR_PORCENTAGEM_INDENIZACAO: number;
}

type ParamsStyle = {
    theme?: Theme;
    handlebutton: string;
}

type ParamsStyleTheme = {
    theme?: Theme;
}

const Accordion = styled(AccordionMui)(`
        padding: 0;
        min-height: auto;
        box-shadow: none;
        
        border-radius: 0 !important;

        &.Mui-expanded {
            margin: 0;
        }

        &:before {
            display: none;
        }
`)

const AccordionSummary = styled(AccordionSummaryMui)(
    ({ theme }: ParamsStyleTheme) => `
        padding: 0;
        align-items: start;
        height: auto;
        min-height: auto;

        &.Mui-expanded {
            height: auto;
            min-height: auto;
        }

        .MuiAccordionSummary-content {
            margin: 0;
            cursor: default;

            &.Mui-expanded {
                margin: 0;
            }
        }

        @media(min-width: ${theme?.breakpoints.values.md}px) {
            height: auto;
            min-height: auto;

            &.Mui-expanded {
                margin: 0;
                height: auto;
                min-height: auto;
            }
        }
`)

const AccordionDetails = styled(AccordionDetailsMui)(
    ({ theme }: ParamsStyleTheme) => `
        textAlign: start;
        padding: 1.18rem 0 0;

        @media(min-width: ${theme?.breakpoints.values.md}px) {
            padding: 1.4rem 1.5rem 0 4.2rem;
        }
`)

export const DivContent = styled('div')(`
    width: 100%;
    display: flex;
    align-items: center;
    justify-content: space-between;
    height: 2.8125rem;
    list-style-type: none;
`);

export const ContentPrice = styled('div')(
    ({ theme }: ParamsStyleTheme) => `
        width: calc(100% - 7rem);
        height: 2.8125rem;
        display: flex;
        align-items: end;
        border-radius: 0px;
        justify-content: start;
        border-bottom: 1.5px solid ${theme?.palette.primary.light};

        @media(min-width: ${theme?.breakpoints.values.md}px) {
            width: calc(100% - 9.75rem);
            border-radius: 0 0 0 5px;
            border-color: ${theme?.palette.primary.main};
        }
`);

export const ContentIcon = styled('div')(
    ({ theme }: ParamsStyleTheme) => `
        display: none;

        @media(min-width: ${theme?.breakpoints.values.md}px) {
            width: 3.125rem;
            height: 2.8125rem;
            display: flex;
            align-items: center;
            justify-content: center;
            border-radius: 5px;
            background-color: ${theme?.palette.primary.main};
        }

        svg {
            path {
                fill: white;
            }
        }
`);

export const Price = styled('div')(
    ({ theme }: ParamsStyleTheme) => `
        display: flex;
        text-align: center;
        align-items: center;
        justify-content: center;

        width: 5.5rem;
        height: 2.8125rem;
        margin-bottom: -1px;
        background-color: ${theme?.palette.primary.light};

        .price {
            width: 100%;
            display: flex;
            padding: 0 .5rem;
            justify-content: space-between;
        }

        @media(min-width: ${theme?.breakpoints.values.md}px) {
            width: 10rem;
            background-color: ${theme?.palette.primary.main};

            p {
                font-size: .93rem;
            }

            .price {
                padding: 0 1.5rem;

                p {
                    font-size: 1.56rem;
                }
            }
        }
`);

export const ContentTitle = styled('div')(
    ({ theme }: ParamsStyleTheme) => `
        width: calc(100% - 5.5rem);

        display: flex;
        align-items: center;
        justify-content: space-between;

        padding: 0 1rem .5rem 0;

        svg {
            width: 1rem;
            height: 1rem;
            min-width: 1rem;
            min-height: 1rem;
            cursor: pointer;
        }

        @media(min-width: ${theme?.breakpoints.values.md}px) {
            width: calc(100% - 13.125rem);
            padding: 0 3rem .5rem 1rem;
        }
`);

export const Button = styled(ButtonMui)(
    ({ theme, handlebutton }: ParamsStyle) => `
        padding: 0;
        height: 2.8125rem;
        width: 6.5rem;
        font-size: 1rem;
        font-weight: 700;
        border-radius: 5px;
        color: ${handlebutton === 'add' ? theme?.palette.primary.main : theme?.palette.primary.light};
        border: 2px solid ${handlebutton === 'add' ? theme?.palette.primary.main : theme?.palette.primary.light};

        &:hover {
            border: 2px solid ${handlebutton === 'add' ? theme?.palette.primary.main : theme?.palette.primary.light};
        }

        @media(min-width: ${theme?.breakpoints.values.md}px) {
            width: 9rem;
        }
`);

const SingleCard = ({ title, price, icon, text, codProductSingle, description, cdQuotationItem, nrTypeProduct, nR_PORCENTAGEM_INDENIZACAO }: Params) => {
    const [addToCart, setAddToCart] = useState(false);
    const { dataProductCart, handleProductCart } = useContext(DataContext);

    const [expanded, setExpanded] = useState(false);

    const handleIsCarReservation = () => {
        if ((dataProductCart.productPlan.cD_PRODUTO === 2427) && (codProductSingle === 2420)) {
            return true;
        }

        return false;
    }

    const handleService = () => {
        handleProductCart({
            bodyBase: {
                cD_COTACAO: 0,
                cD_PEDIDO: 0,
                customerId: 0,
            },
            body: {
                cD_COTACAO_ITEM: parseFloat(cdQuotationItem),
                cD_PRODUTO: codProductSingle,
                nM_PRODUTO: title,
                nR_TIPO_PRODUTO: nrTypeProduct,
                nR_PORCENTAGEM_INDENIZACAO: nR_PORCENTAGEM_INDENIZACAO,
                vL_TOTAL: `R$ ${price}`
            },
            addProduct: !addToCart,
            productPlan: false
        });
    }

    useEffect(() => {
        if (dataProductCart?.productAdd) {
            if (dataProductCart.productAdd?.findIndex(({ cD_PRODUTO }) => cD_PRODUTO === codProductSingle) > -1) {
                setAddToCart(true);
            } else {
                setAddToCart(false);
            }
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [dataProductCart]);

    return (
        <Accordion expanded={expanded}>
            <AccordionSummary aria-controls="panel1bh-content" id="panel1a-header">
                <DivContent>
                    <ContentPrice>
                        <ContentIcon>
                            {icon}
                        </ContentIcon>

                        <ContentTitle>
                            <Typography variant='subtitle2' padding={0} fontWeight="600">
                                {title}
                            </Typography>
                            {expanded ?
                                <TakeArrowQuestionsIcon onClick={() => setExpanded(false)} />
                                :
                                <TakeQuestionsIcon onClick={() => setExpanded(true)} />
                            }
                        </ContentTitle>

                        <Price>
                            {price ?
                                <div className='price'>
                                    <Typography fontSize='1rem' fontWeight="bold" color="white">
                                        R$
                                    </Typography>
                                    <Typography fontSize='1rem' fontWeight="bold" color="white">
                                        {price}
                                    </Typography>
                                </div>
                                :
                                <Typography className='text-price' fontSize={12} fontWeight="bold" color="white" maxWidth={122}>
                                    {text}
                                </Typography>
                            }
                        </Price>
                    </ContentPrice>
                    <Button
                        variant="outlined"
                        disabled={handleIsCarReservation()}
                        handlebutton={addToCart ? 'remove' : 'add'}
                        onClick={() => handleService()}
                    >
                        {handleIsCarReservation() ?
                            <Typography fontSize='.675rem' fontWeight='600' lineHeight='1.2' paddingTop='.3rem' sx={{ opacity: .4 }}>
                                Serviço já incluso no plano selecionado
                            </Typography>
                            :
                            addToCart ? 'REMOVER' : 'ADICIONAR'
                        }
                    </Button>
                </DivContent>
            </AccordionSummary>
            <AccordionDetails>
                <Typography fontSize={14} color='grey.600' lineHeight='17px'>
                    {description}
                </Typography>
            </AccordionDetails>
        </Accordion>
    )
}

export default SingleCard;